$(function() {
    //本文中のオブジェクトをすべて取得
    const $tags = $('#content').children();

    //各オブジェクトにつき、htmlを文字列として取得し、条件にマッチするかチェック
    const array = [];
    let i = 1;
    $tags.each(function(){
        const temp = $('<div>');
        temp.append($(this).clone(true));
        const html = temp.html();
        const matchItems = html.match(/^<h([1-6]).*?>[\s\S]+?<\/h[1-6]>$/i);

        //マッチした場合
        if(matchItems) {
            //リンク先にidを追加
            $(this).attr('id', 'index-' + i);

            //リンクを追加した文字列を目次に使用する文字列として格納
            const text = '<a href="#index-' + i + '">' + $(this).text() + '</a>'
            matchItems.push(text);

            //配列に格納
            array.push(matchItems);
            i++;
        }
    });

    //目次を表示
    let content = "";
    let currentLevel = 2;
    const arrayLength = array.length;
    for(let i = 0; i < arrayLength; i++){
        let result = "";

        //最初の項目のとき
        if(i === 0) {
            result = '<li class="article__index-item">' + array[i][2];

        //2番目以降のとき
        } else {
            const headingLevel = array[i][1];

            //見出しレベルが上がるとき
            if(headingLevel > currentLevel){
                const diff = headingLevel - currentLevel;
                for(let i = 0; i < diff; i++) {
                    currentLevel++;
                    result = '<ul class="article__index-item-list article__index-item-list--' + currentLevel + '"><li class="article__index-item">';
                }
                result = result + array[i][2];

            //見出しレベルが同じとき
            } else if(headingLevel == currentLevel) {
                result = '</li><li class="article__index-item">' + array[i][2];

            //見出しレベルが下がるとき
            } else if(headingLevel < currentLevel){
                const diff = currentLevel - headingLevel;
                result = '</li>';
                for(let i = 0; i < diff; i++) {
                    currentLevel--;
                    result = result + '</ul></li>';
                }
                result = result + '<li class="article__index-item">' + array[i][2];
            }
        }
        //結果を変数に格納
        content = content + result;
    }
    //最終的な結果を出力
    $('#index').append(content);

    // SPではデフォルト閉じ
    if(window.innerWidth <= 768) {
      $('details.article__index').removeAttr('open');
    }
  });